import React, { useEffect,useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-modal';
import {LoginPopupStyles }from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import { setUserBrandAddAction, setUserBrandDelAction} from '../../modules/common/brandModule';
import { setClipBrandIdAction} from '../../modules/su/userBrandModule';
import { remove } from 'lodash';
import {isMobileOnly} from 'react-device-detect';

const BrBrandHomeItemBlock = styled.div`
    //float : ${props => props.float || 'left'};
    //float : left;
    position: relative;
    width: 266px;
    //height: 212px;
    line-height: 1.4;
    //padding-right: 30px;
    font-size: 14px;
    ${isMobileOnly?`
        min-width:40vw;
        margin-right: 4vw;    
    `:`
        float : left;
        height: 212px;
        padding-right: 30px;
    `};
`;

const BrBrandHomeItemLogoPBlock = styled.p`
    margin-bottom: 12px;
    height: 28px;
`;

const BrBrandHomeItemTitlePBlock = styled.p`
    //height: 38px;
    overflow: hidden;
    ${isMobileOnly?`
        text-overflow: ellipsis;
        font-size:0.9em;
    `:`
        height: 38px;    
    `};
`;

const BrBrandHomeItemCateUlBlock = styled.ul`
    ${isMobileOnly?`
    margin-top: 0px;
    margin-left: -5px;
    max-height: 32px;
    overflow: hidden;  
    `:`
    margin-top: 10px;
    margin-left: -5px;
    height: 70px;
    overflow: hidden;  
    `};

`;

const BrBrandHomeItemCateDotLiBlock = styled.li`
${isMobileOnly?`
    margin-left: 5px;
    margin-top: 8px;

    display: inline-block;
    padding: 4px 8px 4px;
    color: #666;
    border: 1px dashed #666;
    border-radius: 20px;
    font-size: 10px;
    `:`
    margin-left: 5px;
    margin-top: 10px;

    display: inline-block;
    padding: 4px 10px 5px;
    color: #666;
    border: 1px dashed #666;
    border-radius: 20px;
    font-size: 13px;
    `};
`;

const BrBrandHomeItemCateSpanBlock = styled.span`

`;

const BrBrandHomeItemBottomBoxBlock = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    //height: 40px;
    height: ${isMobileOnly?'30px':'40px'};
    overflow: hidden;
    font-family: Montserrat,sans-serif;
    ${isMobileOnly&&"display:flex"};
    
    ::after {
        content: '';
        display: block;
        clear: both;
    }
`;

const BrBrandHomeItemBottomBoxHomeLinkBlock = styled.div`
    //float: left;
    ${!isMobileOnly&&`
        float: left;
        padding: 11px 10px 10px;
        margin-right: 8px;        
    `};
    width: ${isMobileOnly?'32vw':'186px'};
    height: ${isMobileOnly?'30px':'40px'};
    //padding: 11px 10px 10px;
    //margin-right: 8px;
    color: #fff;
    background-color: #111;
    text-align: center;
    font-size: ${isMobileOnly?"0.8em":"14px"};
    display: ${isMobileOnly?'flex':'inline-block'};
    border-radius: 4px;
    
    ${isMobileOnly&&`
        align-items: center;
        justify-content: center;    
    `};

    ::after {
        content: '';
        display: inline-block;
        width: 7px;
        height: 11px;
        margin-left: 10px;
        background: url(/assets/images/icon/btn_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(360deg);
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

const BrBrandHomeItemBottomBoxHomeLinkSpanBlock = styled.span`
    color: #79b88a;
    font-weight: 700;
    display:${props => props.show};
    ${isMobileOnly&&"font-size: 0.6em"};
    ${isMobileOnly&&`
    font-size: 12px;
    margin-left: 5px;
    line-height: 14px; 
    `};
`;

const BrBrandHomeItemBottomBoxLikeBtBlock = styled.button`
    ${!isMobileOnly&&"float: left"};
    background: ${props => props.btnUrl};

    width: ${isMobileOnly?"30px":"40px"};
    height: ${isMobileOnly?"30px":"40px"};
    border-radius: 4px;
`;

const BrBrandHomeItemMBlock = styled.div`
    .container-left {
        float: left;
    }
    .container-right {
        float: right;
        width: calc(100% - 100px);
        //padding-top: 15px;
    }

    .brand-name {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `:`
        font-size: 14px;
        font-weight: 500;
        line-height: 1.2;
        color: #333333;
        margin-bottom: 4px;
        padding: 8px 0;
        `};

        
        width: calc(100% - 40px);
    }

    .brand-info {
        ${isMobileOnly?`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `:`
        line-height: 1.33;
        font-size: 12px;
        color: #666666;
        `};
    }

    .brand-home {
        font-size: 14px;
        line-height: 1.57;
        color: #111111;
        top: 6px;
        position: relative;
    }
`;

const BrandThumBlock = styled.div`
    ${isMobileOnly?`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `:`
    width: 90px;
    height: 90px;
    border-radius: 45px;
    margin-right: 10px;
    background-size: 90px 90px;
    `};
    
    background-image : url(${props => props.backgroundimage});
    background-position: center;
`;

const BrandHomeHeaderInfoLikeButtonBlock = styled.button`
    width: 32px;
    height: 33px;
    background: ${props => props.btnUrl};
    background-size: 18px 18.8px;
`;

const new2 = "NEW ";
const Home = "BRAND HOME"

//Modal.setAppElement('#modal-root');

const BrBrandHomeItem = ({img, brandInfo, brInfo, idHome, brnd_han, reg_dtm}) => {
    const dispatch = useDispatch();
    const [openModal, setOpenModal] = useState(false);
    const [isClipAdd, setIsClipAdd] = useState(false);
    const [isClipDel, setIsClipDel] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);

    let date = new Date();
    let date1 = new Date(reg_dtm)

    let diffDay = (date.getTime()-date1.getTime())/(1000*60*60*24)
    //console.log("diffDay = "+diffDay);

    const { accessToken ,clipBrandIds, brandClipResult, id} = useSelector(
        ({ userReducer, brandItemsReducer, userBrandReducer }) => ({
            accessToken: userReducer.accessToken,
            clipBrandIds: userBrandReducer.clipBrandIds,
            brandClipResult: brandItemsReducer.brandClipResult,
            id: userReducer.id,
        })
    );

    useEffect(() => {
        if(accessToken !== null){
            onCloseModal();
        }

        return ()=>{
            //console.log( "BrBrandHomeItem end = ");
        };

    }, [accessToken]);

    useEffect(() => {

        //console.log("BrBrandHomeItem" + JSON.stringify(clipBrandIds))

        if(isClipAdd){
            if(clipBrandIds === null || clipBrandIds === undefined || (clipBrandIds && clipBrandIds.length < 1)){
                let clipSum = [];
                clipSum.push(idHome);
                //console.log("BrBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
            else{
                let clipSum = [...new Set(clipBrandIds.concat(idHome))];
                //console.log("BrBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipAdd(false);
            }
        }
        else if(isClipDel){
            if(clipBrandIds != null){
                let clipSum = [...clipBrandIds];
                remove(clipSum,(obj)=>{return obj === idHome})
                //console.log("BrBrandHomeItem" + JSON.stringify(clipSum))
                dispatch(setClipBrandIdAction(clipSum));
                setIsClipDel(false);
            }
        }

    }, [brandClipResult]);

    //로그인 팝업 뜨고 로그인 완료 후, 좋아요 리스트 요청(메인화면에서 요청) 후 처리.
    useEffect(() => {
        if(accessToken !== null && fromLoginPU === true){

            //로그인 완료 후 이미 좋아요 포함되어 있는 경우 요청하지 않음.
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){

            }
            else{

                dispatch(setUserBrandAddAction(id,idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
            setFromLoginPU(false);
        }

    }, [clipBrandIds]);

    const onOpenModal = () => {
        setOpenModal(true);
    }

    // Modal 닫기
    const onCloseModal = () => {
        setOpenModal(false);
    }

    const onHandleLike = (idHome) =>{
        console.log("onHandleLike = " + idHome)
        //비로그인
        if (accessToken === null){
            onOpenModal();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
        }
        else{
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){
                dispatch(setUserBrandDelAction(id,idHome));
                setIsClipAdd(false);
                setIsClipDel(true);
            }
            else{
                dispatch(setUserBrandAddAction(id,idHome));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
        }

    }

    const getLikeBtn = () => {
        //비로그인
        if(accessToken === null){

            return "url(/assets/images/icon/bookmark-icon.png) center center/cover no-repeat"
        }
        else{
            if(clipBrandIds != null && clipBrandIds.length >0 && clipBrandIds.includes(idHome)){
                return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
            }
            else{
                return "url(/assets/images/icon/bookmark-icon.png) center center/cover no-repeat"
            }

        }
        //return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
    }

    const getLikeBtnMobile = () => {

        //비로그인
        if (accessToken === null) {
            return "url(/assets/images/icon/bookmark-icon-gray.png) center center/cover no-repeat"
        }
        else {
            if (clipBrandIds != null && clipBrandIds.length > 0 && clipBrandIds.indexOf(idHome) > -1) {
                return "url(/assets/images/icon/bookmark-icon-trans-icon.png) center center/cover no-repeat"
            }
            else {
                return "url(/assets/images/icon/bookmark-icon-gray.png) center center/cover no-repeat"
            }

        }
        //return "url(/assets/images/icon/bookmark-icon-active.png) center center/cover no-repeat"
    }

    //브랜드 카테고리가 없는 경우
    if(Object.keys(brInfo).includes('cate') === false || brInfo.cate === undefined || brInfo.cate === null){
        return (
            isMobileOnly?
            <BrBrandHomeItemMBlock className="clearfix margin_b-40">
                <div className="clearfix margin_b-20">
                    <div className="container-left">
                        <Link to={"/brHome/" + idHome}>
                            <BrandThumBlock backgroundimage={img.replace(/ /g, "%20")} />
                        </Link>
                    </div>
                    <div className="container-right">
                        <div className="clearfix">
                            <div className="f-left brand-name">
                                <Link to={"/brHome/" + idHome }>
                                            {brnd_han})
                                </Link>
                                <BrBrandHomeItemBottomBoxHomeLinkSpanBlock show={diffDay>14 ? 'none':''}>
                                {new2}
                                </BrBrandHomeItemBottomBoxHomeLinkSpanBlock>
                            </div>
                            <BrandHomeHeaderInfoLikeButtonBlock className="f-right" onClick={() => onHandleLike(idHome)}
                            btnUrl={getLikeBtnMobile()} >
                            </BrandHomeHeaderInfoLikeButtonBlock>
                        </div>
                        <div >
                            <div className="brand-info">
                            {brandInfo}
                            </div>
                        </div>
                    </div>
                </div>
                <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>
            </BrBrandHomeItemMBlock>
            :
                <BrBrandHomeItemBlock>
                    <BrBrandHomeItemLogoPBlock>
                        <img src={img} alt=""/>
                    </BrBrandHomeItemLogoPBlock>
                    <BrBrandHomeItemTitlePBlock>
                        {brandInfo}
                    </BrBrandHomeItemTitlePBlock>
                    <BrBrandHomeItemCateUlBlock>

                    </BrBrandHomeItemCateUlBlock>
                    <BrBrandHomeItemBottomBoxBlock>
                        <Link to={"/brHome/"+idHome}>
                            <BrBrandHomeItemBottomBoxHomeLinkBlock>
                                <BrBrandHomeItemBottomBoxHomeLinkSpanBlock show={diffDay>14 ? 'none':''}>
                                        {new2}
                                </BrBrandHomeItemBottomBoxHomeLinkSpanBlock>
                                        {Home}
                            </BrBrandHomeItemBottomBoxHomeLinkBlock>
                        </Link>
                        <BrBrandHomeItemBottomBoxLikeBtBlock onClick = {()=>onHandleLike(idHome)}
                        btnUrl = {getLikeBtn()}>

                        </BrBrandHomeItemBottomBoxLikeBtBlock>
                    </BrBrandHomeItemBottomBoxBlock>

                <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>
                </BrBrandHomeItemBlock>
        );
    }

    return (
        isMobileOnly?
            <BrBrandHomeItemMBlock className="clearfix">
                <div className="clearfix margin_b-20">
                    <div className="container-left">
                        <Link to={"/brHome/" + idHome}>
                            <BrandThumBlock backgroundimage={img.replace(/ /g, "%20")} />
                        </Link>
                    </div>
                    <div className="container-right">
                        <div className="clearfix">
                            <div className="f-left brand-name">
                                
                                <Link to={"/brHome/" + idHome }>
                                            {brnd_han}
                                </Link>
                                <BrBrandHomeItemBottomBoxHomeLinkSpanBlock show={diffDay>14 ? 'none':''}>
                                {new2}
                                </BrBrandHomeItemBottomBoxHomeLinkSpanBlock>
                            </div>
                            <BrandHomeHeaderInfoLikeButtonBlock className="f-right" onClick={() => onHandleLike(idHome)}
                            btnUrl={getLikeBtnMobile()} >
                            </BrandHomeHeaderInfoLikeButtonBlock>
                            </div>
                        <div >
                            <div className="brand-info">
                            {brandInfo}
                            </div>
                        </div>
                        <BrBrandHomeItemCateUlBlock>
                        {
                            brInfo.cate.map((item)=>{
                                return(<BrBrandHomeItemCateDotLiBlock key={item.key}>
                                    <BrBrandHomeItemCateSpanBlock>
                                    {item.key}
                                    </BrBrandHomeItemCateSpanBlock>
                                </BrBrandHomeItemCateDotLiBlock>)
                            })
                        }
                        </BrBrandHomeItemCateUlBlock>
                    </div>
                </div>
                <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>
            </BrBrandHomeItemMBlock>
            :
        <BrBrandHomeItemBlock>
            <BrBrandHomeItemLogoPBlock>
                <img src={img} alt=""/>
            </BrBrandHomeItemLogoPBlock>
            <BrBrandHomeItemTitlePBlock>
                {brandInfo}
            </BrBrandHomeItemTitlePBlock>
            <BrBrandHomeItemCateUlBlock>
            {
                brInfo.cate.map((item)=>{
                    return(<BrBrandHomeItemCateDotLiBlock key={item.key}>
                        <BrBrandHomeItemCateSpanBlock>
                        {item.key}
                        </BrBrandHomeItemCateSpanBlock>
                    </BrBrandHomeItemCateDotLiBlock>)
                })
            }
            </BrBrandHomeItemCateUlBlock>
            <BrBrandHomeItemBottomBoxBlock>
                <Link to={"/brHome/"+idHome}>
                    <BrBrandHomeItemBottomBoxHomeLinkBlock>
                        <BrBrandHomeItemBottomBoxHomeLinkSpanBlock show={diffDay>14 ? 'none':''}>
                                {new2}
                        </BrBrandHomeItemBottomBoxHomeLinkSpanBlock>
                                {Home}
                    </BrBrandHomeItemBottomBoxHomeLinkBlock>
                </Link>
                <BrBrandHomeItemBottomBoxLikeBtBlock onClick = {()=>onHandleLike(idHome)}
                btnUrl = {getLikeBtn()}>

                </BrBrandHomeItemBottomBoxLikeBtBlock>
            </BrBrandHomeItemBottomBoxBlock>

            <Modal
                isOpen={openModal}
                onRequestClose={onCloseModal}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModal}/>
                </Modal>
        </BrBrandHomeItemBlock>
    );

};



export default BrBrandHomeItem;
